import {ChipColorEnum} from 'presentation/components/TagChip/types';

enum RefundDocumentStatusEnum {
	APROVADO = 'aprovado',
	REJEITADO = 'rejeitado',
	EM_ANALISE = 'em_analise',
	PENDENTE = 'pendente',
}

type RefundDocumentRow = {
	id: string;
	status: RefundDocumentStatusEnum;
	documento: string;
	obrigatorio: boolean;
	dataEnvio: string | null;
	anexo: string | null;
	anexoUrl?: string;
};

type SendDocumentsV2Props = {
	handleNextStep: () => void;
};

type RefundDocumentTableProps = {
	rows: RefundDocumentRow[];
	onSendDocument: (row: RefundDocumentRow) => void;
	onOpenAttachment: (row: RefundDocumentRow) => void;
};

type StatusBadgeMeta = {
	label: string;
	color: ChipColorEnum;
};

export {RefundDocumentStatusEnum};
export type {RefundDocumentRow, SendDocumentsV2Props, RefundDocumentTableProps, StatusBadgeMeta};
